export const filterTime = (type, options) => {
  console.log(type);
  console.log(options);
  if (type === 'year') {
    return options.filter((option) => {
      console.log(option);
    });
  }
};
